import React from 'react';
import Arrow from '@magento/venia-ui/venia-static/icons/chevron.svg';
import logoStokes from '@magento/venia-ui/venia-static/icons/logostokes1.jpg';
import logoThinkKitchen from '@magento/venia-ui/venia-static/icons/thinkkitchen.svg';
import Check from '@magento/venia-ui/venia-static/icons/check.svg';
import classes from './storeCheckoutLocatorModal.css';
import { days, getTodayStoreHours } from '../../Header/utils';
import getDirectionGoogleMap from '@magento/peregrine/lib/util/getDirectionGoogleMap';
import { useAppContext } from '@magento/peregrine/lib/context/app';
var StoreDetails = _ref => {
  var {
    selectedStore,
    setOpenScheduleIndex,
    setSelectedStore,
    formatMessage
  } = _ref;
  var {
    name,
    address,
    phone,
    latitude,
    longitude,
    region,
    zipcode,
    country,
    city,
    is_thinkkitchen
  } = selectedStore;
  var [{
    currentStore
  }, {
    setCurrentStore
  }] = useAppContext();
  var STATIC_STRINGS = {
    goBackToStoreList: formatMessage({
      defaultMessage: 'Go Back to Store List',
      id: 'storeSchedule.goBackToStoreList'
    }),
    getDirections: formatMessage({
      defaultMessage: 'Get Directions',
      id: 'GetDirection'
    }),
    selectedStore: formatMessage({
      defaultMessage: 'Selected Store',
      id: 'storeSchedule.selectedStore'
    }),
    selectThisStore: formatMessage({
      defaultMessage: 'Select this Store',
      id: 'storeSchedule.selectThisStore'
    }),
    openingHours: formatMessage({
      defaultMessage: 'Store Hours',
      id: 'storeSchedule.storeHours'
    })
  };
  var storeDetails = "".concat(city, ", ").concat(region, ", ").concat(zipcode, ", ").concat(country === 'CA' ? "Canada" : '');
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    className: classes.goBackStoreListButton,
    onClick: () => {
      setSelectedStore(null);
      setOpenScheduleIndex(null);
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: Arrow,
    alt: 'arrow'
  }), /*#__PURE__*/React.createElement("div", null, STATIC_STRINGS.goBackToStoreList)), /*#__PURE__*/React.createElement("div", {
    className: classes.storeInfo
  }, is_thinkkitchen == 1 ? /*#__PURE__*/React.createElement("img", {
    className: classes.thinkkitchen,
    src: logoThinkKitchen,
    alt: name
  }) : /*#__PURE__*/React.createElement("img", {
    src: logoStokes,
    alt: name
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.storeName
  }, name), /*#__PURE__*/React.createElement("div", {
    className: classes.storeAddress
  }, address), /*#__PURE__*/React.createElement("div", {
    className: classes.storeAddress
  }, storeDetails), /*#__PURE__*/React.createElement("a", {
    href: "tel:".concat(phone),
    className: classes.storePhone
  }, phone), /*#__PURE__*/React.createElement("div", {
    className: classes.storeActionsContainer
  }, /*#__PURE__*/React.createElement("button", {
    className: classes.getDirectionButton,
    onClick: () => {
      getDirectionGoogleMap({
        address,
        region,
        zipcode,
        lat: latitude,
        lng: longitude
      });
    }
  }, STATIC_STRINGS.getDirections), currentStore && currentStore.store_id == selectedStore.store_id ? /*#__PURE__*/React.createElement("div", {
    className: classes.checkingContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.check
  }, /*#__PURE__*/React.createElement("img", {
    src: Check,
    alt: 'Check'
  })), STATIC_STRINGS.selectedStore) : /*#__PURE__*/React.createElement("button", {
    className: classes.selectThisStoreButton,
    onClick: () => {
      setSelectedStore(selectedStore);
      setCurrentStore(selectedStore);
    }
  }, STATIC_STRINGS.selectThisStore))), /*#__PURE__*/React.createElement("div", {
    className: classes.storeDetailsHoursContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, STATIC_STRINGS.openingHours), days.map(d => {
    var schedule = selectedStore.schedule;
    var {
      time,
      todayLabel
    } = getTodayStoreHours({
      schedule
    });
    var t = '';
    if (todayLabel === d) {
      t = 'Today';
    }
    return /*#__PURE__*/React.createElement("div", {
      className: classes["dayTimeRow".concat(t)]
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.todayLabel
    }, formatMessage({
      defaultMessage: d,
      id: d
    })), /*#__PURE__*/React.createElement("div", null, time));
  })));
};
export default StoreDetails;